import axios from 'axios';
import { commonConstants } from '../constants/commonConstants';
import appConfig from '../../config/config';
import { authHeader } from '../helper/authHeader';
import axiosInstance from '../helper/axiosInstance';
import { logoutUser } from './login.action';

export const ClearArray = () => {
  return {
    type: commonConstants.CLEAR_ARRAY_SUCCESS
  };
};

export const GetComments = (id, type, start, fetchCommentLimit, callback) => {
  return (dispatch) => {
    axiosInstance
      .get(`comment/fetch?type_id=${id}&type=${type}&from=${start}&limit=${fetchCommentLimit}`)
      .then((response) => {
        callback(response.data);
        dispatch({
          type: commonConstants.GET_COMMENTS_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        callback('error');
        dispatch({
          type: commonConstants.GET_COMMENTS_FALIURE,
          payload: error
        });
      });
  };
};

export function GetReplyComments(cid, start, fetchCommentLimit, callback) {
  return (dispatch) => {
    axiosInstance
      .get(`comment/fetch_reply?cid=${cid}&from=${start}&limit=${fetchCommentLimit}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch({
            type: commonConstants.GET_REPLY_COMMENTS_SUCCESS,
            payload: response.data
          });
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        callback('error');
        dispatch({
          type: commonConstants.GET_REPLY_COMMENTS_FALIURE,
          payload: error
        });
      });
  };
}

export function PostComment(jsonObj, callback) {
  return (dispatch) => {
    axiosInstance
      .post('comment/save', jsonObj)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch({
            type: commonConstants.POST_COMMENT_SUCCESS
          });
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        callback('error');
        dispatch({
          type: commonConstants.POST_COMMENT_FAILURE
        });
      });
  };
}
export function doSearch(pagination = 0, type = '', value = '', specs = '', callback) {
  const apiUrl = specs ? 'data' : 'datanew';
  return (dispatch) => {
    axiosInstance
      .get(
        `search/${apiUrl}?from=${pagination}&to=50&type=${type}&val=${
          'keyword:' + value
        }&specialities=${specs}`
      )
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        callback('error');
      });
  };
}
export function postSearchData(search_type, data, callback) {
  return (dispatch) => {
    axiosInstance
      .post('search/usersearchdata', { search_type, data })
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        callback('error');
      });
  };
}
export function fetchSearchData(callback) {
  return (dispatch) => {
    axiosInstance
      .get('search/usersearchlisting?from=0&to=10')
      .then((response) => {
        if (response.data) {
          let searched = response.data?.data?.length > 0 ? response.data?.data : [];
          if (searched?.length > 0) {
            let temp_searched = [];
            searched?.forEach((_each) => {
              console.log('SEARCHED', _each);
              if (_each?.search_type == 'inputText') {
                console.log('PARSED_SEARCH_DATA', JSON.parse(_each.data));
                temp_searched?.push({
                  type: 'inputText',
                  text: JSON.parse(_each.data)
                });
              } else if (_each?.search_type == 'speciality') {
                console.log('PARSED_SEARCH', JSON.parse(_each.data));
                let { specialities_name, master_specialities_id } = JSON.parse(_each.data);
                temp_searched?.push({
                  type: 'speciality',
                  specialities_name,
                  master_specialities_id
                });
              }
            });
            if (temp_searched?.length > 0) {
              dispatch({ type: 'RECENT_SEARCHES', payload: temp_searched });
              callback(temp_searched);
            }
          }
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        callback([]);
      });
  };
}
//search/data?from=0&to=25&type=&val=covid&specialities=
export function getFcmToken(setFirebaseToken) {
  return (dispatch) => {
    axiosInstance
      .get('fcm/token')
      .then((res) => {
        setFirebaseToken(res?.data?.data?.token);
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        console.log('error', error);
      });
  };
}
export const fetchSearchSuggestions = (input, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`search/autocomplete?from=0&to=20&val=${input}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        callback('error');
      });
  };
};
export async function sendVideoAnalytics(report) {
  console.log('TRACK REPORT', report);
  try {
    const response = await axiosInstance.post('tracking/videotimingdata', report);

    let status_code = response.data.status_code;
    if (status_code == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}
